import cx from "clsx";
import React from "react";
import Styles from "./CancelButton.module.scss";

type Props = {
	className?: string;
	disabled?: boolean;
	label?: string;
	onClick: () => void;
};

const PCancelButton: React.FC<Props> = ({
	disabled = false,
	label = "キャンセル",
	className,
	onClick
}: Props) => (
	<button
		className={cx(Styles.Button, className)}
		disabled={disabled}
		onClick={onClick}
		type="button"
	>
		{label}
	</button>
);

export const CancelButton = React.memo(PCancelButton);
